import { SET_SERVICE_ZONE_TIMEZONE } from 'actions';

export function setServiceZoneTimezone(serviceZoneTimezone: string) {
  return { serviceZoneTimezone, type: SET_SERVICE_ZONE_TIMEZONE };
}
